module.exports={cookies:"Cookie",help:"說明",privacy:"隱私權 (已更新)",signInWithId:"以 Adobe ID 登入",termsOfUse:"使用條款"};